module.exports = __webpack_public_path__ + "img/circle.049ffb9e.svg";